import { Component } from '@angular/core';
import { from,fromEvent, Observable,Subscription } from 'rxjs';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	offlineEvent: Observable < Event > ;
	onlineEvent: Observable < Event > ;
	subscriptions: Subscription[] = [];

	ngOnInit(): void {
		this.handleAppConnectivityChanges();
	}

	private handleAppConnectivityChanges(): void {
		this.onlineEvent = fromEvent(window, 'online');
		this.offlineEvent = fromEvent(window, 'offline');

		this.subscriptions.push(this.onlineEvent.subscribe(e => {
			// handle online mode

		}));

		this.subscriptions.push(this.offlineEvent.subscribe(e => {
			// handle offline mode

		}));
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

}
